





















































import {
  PreCollection,
  PreCollectionContentType,
  PreCollectionThumbnail,
} from '@/resource/pre-collection/pre-collection.model';
import { Component, Prop, Vue } from 'vue-property-decorator';
import getLevelPremadePaper from '@/utils/common/get-level-premade-paper';
import generatePrecollectionUrl from '@/utils/common/generate-precollection-url';
import truncateString from '@/utils/common/truncate';

@Component({
  components: {},
})
export default class PreCollectionItem extends Vue {
  @Prop({ required: true })
  preCollection!: PreCollection;

  @Prop({ default: null })
  listTitle: string;

  get level() {
    return getLevelPremadePaper(this.preCollection.form);
  }

  get title() {
    return truncateString(this.preCollection.name, 34);
  }

  get description() {
    const text =
      this.preCollection.details + ': ' + this.preCollection.description;

    return truncateString(text, 60);
  }

  get titleMobile() {
    return truncateString(this.preCollection.name, 28);
  }

  get descriptionMobile() {
    const text =
      this.preCollection.details + ': ' + this.preCollection.description;

    return truncateString(text, 30);
  }

  get thumbnail() {
    let thumbnail = 'img_thumbnail_default';

    switch (this.preCollection.thumbnail) {
      case PreCollectionThumbnail.PERCUBAAN:
        thumbnail = 'img_thumbnail_percubaan';
        break;
      case PreCollectionThumbnail.SPM:
        thumbnail = 'img_thumbnail_spm';
        break;
      case PreCollectionThumbnail.TOPIKAL:
        thumbnail = 'img_thumbnail_topikal';
        break;
      case PreCollectionThumbnail.UASA:
        thumbnail = 'img_thumbnail_uasa';
        break;
      case PreCollectionThumbnail.COURSE:
        thumbnail = 'img_thumbnail_course';
        break;
      case PreCollectionThumbnail.NOTE:
        thumbnail = 'img_thumbnail_note';
        break;
      case PreCollectionThumbnail.MODUL:
        thumbnail = 'img_thumbnail_modul';
        break;
    }

    return require(`@/assets/image/${thumbnail}.png`);
  }

  itemClick() {
    const itemName = generatePrecollectionUrl(this.preCollection);

    this.$sendMpEvent({
      event: this.$mp_value.PremadePaperClick,
      properties: {
        uuid: this.preCollection.uuid,
        name: this.preCollection.name,
        form: this.preCollection.form,
        type: this.preCollection.type,
        year: this.preCollection.year,
        subjectUuid: this.preCollection.subject.uuid,
        isPremium: this.preCollection.isPremium,
        listTitle: this.listTitle,
        contentType: this.preCollection.course
          ? PreCollectionContentType.Course
          : this.preCollection.pdfLink
          ? PreCollectionContentType.Pdf
          : this.preCollection.collection
          ? PreCollectionContentType.Collection
          : PreCollectionContentType.PaperGenerated,
      },
    });

    const routeData = this.$router.resolve({
      path: `/browse/${itemName}`,
    });
    window.open(routeData.href, '_blank');
  }
}
